<template>
  <ul class="urls-list">
    <website-settings-list-title :listType="listType"
                                 @openInput="showUrlInput" />
    <website-settings-input v-if="showInput"
                            :urlSettings="urlSettings"
                            :inputType="listType"
                            @hideInput="hideUrlInput"
                            @addUrl="addUrlSetting" />
    <li v-for="(url, index) in urls"
        :key="index">
      <website-settings-list-item :url="url"
                                  @deleteSetting="deleteUrlSetting" />
    </li>  
  </ul>  
</template>

<script>
  import WebsiteSettingsListItem  from '@/components/Child/ChildWebsiteSettings/WebsiteSettingsListItem'
  import WebsiteSettingsListTitle from '@/components/Child/ChildWebsiteSettings/WebsiteSettingsListTitle'
  import WebsiteSettingsInput     from '@/components/Child/ChildWebsiteSettings/WebsiteSettingsInput'

  export default {
    props: {
      urls: {
        type: Array,
        required: true
      },

      listType: {
        type: String,
        required: true
      },

      urlSettings: {
        type: Array,
        required: true
      }
    },

    components: {
      WebsiteSettingsListItem,
      WebsiteSettingsListTitle,
      WebsiteSettingsInput
    },

    data() {
      return {
        showInput: false
      }
    },

    methods: {
      showUrlInput() {
        this.showInput = true
      },

      hideUrlInput() {
        this.showInput = false
      },

      addUrlSetting(url) {
        this.$emit('addUrlSetting', {
          url: url,
          mode: this.listType
        })
      },
      
      deleteUrlSetting(id) {
        this.$emit('deleteUrlSetting', id)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .urls-list {
    list-style: none;
    padding: 0;
    margin: 0 0 40px 0;
    color: #3e3a3b;
  }
</style>
